import { fallback } from "@tanstack/zod-adapter"
import { z } from "zod"

import {
  PriceChangeHistorySortField,
  PriceChangeSubmissionStatus,
  PriceChangeType,
  SortingOrder,
} from "@/graphql/codegen/graphql"

export const priceChangeSearchSchema = z.object({
  changeType: z.nativeEnum(PriceChangeType).optional(),
  supplierId: z.string().optional(),
  customerIds: z.array(z.string()).optional(),
  productCategoryId: z.string().optional(),
  productClassId: z.string().optional(),
  specificProductIds: z.array(z.string()).optional(),
  shipFromId: z.string().optional(),
  shipToId: z.string().optional(),
  effectiveDate: z.string().optional(),
  productManagerId: z.string().optional(),
  page: z.number().optional(),
})

export const reviewSubmissionSearchSchema = z.object({
  page: fallback(z.number().int().positive().optional(), undefined),
})

export const priceChangeHistorySearchSchema = z.object({
  query: z.string().optional(),
  assignedToIds: z.array(z.string()).optional(),
  changeType: fallback(z.nativeEnum(PriceChangeType), PriceChangeType.SellingPrice),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  status: z.array(z.nativeEnum(PriceChangeSubmissionStatus)).optional(),
  field: fallback(z.nativeEnum(PriceChangeHistorySortField), PriceChangeHistorySortField.UpdatedOn),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Desc),
})

export const purchaseCostHistorySearchSchema = z.object({
  query: z.string().optional(),
  changeType: fallback(z.nativeEnum(PriceChangeType), PriceChangeType.PurchasingCost),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  field: fallback(z.nativeEnum(PriceChangeHistorySortField), PriceChangeHistorySortField.UpdatedOn),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Desc),
})

export type PriceChangeSearchParams = z.infer<typeof priceChangeSearchSchema>
export type ReviewSubmissionSearchParams = z.infer<typeof reviewSubmissionSearchSchema>
export type PriceChangeHistorySearchParams = z.infer<typeof priceChangeHistorySearchSchema>
